/**
 * Whitelist for vuex-persist — keep payloads small (localStorage ~5MB cap).
 * Full course documents live in Vuex memory and are re-fetched from Storage.
 * Do not persist prevUnit / prevSection / prevWeek / prevMission here.
 * Admin previews use query params + src/helpers/previewBridge.js instead.
 */
export function vuexPersistReducer(state) {
  return {
    UserData: {
      user: state.UserData?.user,
      roles: state.UserData?.roles,
      isAuthenticated: state.UserData?.isAuthenticated,
      profileComplete: state.UserData?.profileComplete,
      oldFullPath: state.UserData?.oldFullPath,
    },
    AppData: {
      cid: state.AppData?.cid,
      courseDrawer: state.AppData?.courseDrawer,
      notesOpen: state.AppData?.notesOpen,
      highlightsOpen: state.AppData?.highlightsOpen,
      activeUnit: state.AppData?.activeUnit,
      prevUnitId: state.AppData?.prevUnitId,
      prevSectionId: state.AppData?.prevSectionId,
    },
  }
}
